import type { BlogPost } from '../types'

export const CINCO_ERRORES_AL_PEDIR_PRESUPUESTOS_SOLARES: BlogPost = {
  slug: '5-errores-al-pedir-presupuestos-solares',
  lang: 'es',
  topicId: '5-bledow-oferty-pv',
  title: '5 errores al pedir presupuestos solares',
  metaDescription:
    '¿Recopilando presupuestos para una instalación solar? Conozca los 5 errores más frecuentes - ' +
    'desde el teléfono hasta ignorar las ayudas del IDAE.',
  keywords: [
    'errores presupuesto instalación solar',
    'cómo comparar presupuestos fotovoltaicos',
    'qué mirar en un presupuesto solar',
    'ayudas IDAE autoconsumo',
    'elegir instalador solar',
  ],
  publishedAt: '2026-07-12',
  excerpt:
    'Quien recopila presupuestos para una instalación solar suele cometer uno de estos cinco ' +
    'errores - desde dar el teléfono demasiado pronto hasta olvidar las ayudas del IDAE al ' +
    'calcular la rentabilidad. Así se pueden evitar.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Una instalación solar es un gasto de varios miles de euros - y aun así muchas personas ' +
        'aceptan el primer presupuesto que reciben, o deciden bajo la presión de una llamada ' +
        'comercial. Estos son los cinco errores que más dinero suelen costar en la práctica, y cómo ' +
        'evitarlos.',
    },
    {
      type: 'heading',
      text: '1. Aceptar el primer presupuesto sin comparar',
    },
    {
      type: 'paragraph',
      text:
        'El precio de una instalación de la misma potencia puede variar bastante entre empresas, ' +
        'incluso con componentes similares. Si solo se pide presupuesto a una empresa, no hay ' +
        'punto de referencia para saber si el precio es razonable o está inflado. Reunir al menos ' +
        'tres presupuestos comparables antes de firmar nada es la forma más sencilla de ahorrar de ' +
        'verdad.',
    },
    {
      type: 'heading',
      text: '2. Dar el teléfono y el correo electrónico demasiado pronto',
    },
    {
      type: 'paragraph',
      text:
        'En muchos portales comparadores hay que indicar el teléfono y el correo electrónico ya al ' +
        'enviar la solicitud - antes incluso de que ninguna empresa haya presentado un presupuesto. ' +
        'El resultado suele ser una avalancha de llamadas de varias empresas a la vez, antes de ' +
        'haber podido comparar siquiera dos presupuestos con calma. Es preferible optar por ' +
        'soluciones en las que los datos de contacto solo llegan a la empresa concreta que usted ' +
        'elija, y no antes.',
    },
    {
      type: 'heading',
      text: '3. Fijarse solo en el precio final',
    },
    {
      type: 'paragraph',
      text:
        'Dos presupuestos para "10 kWp" no tienen por qué ser el mismo producto. Conviene revisar ' +
        'el desglose: qué paneles y qué inversor concretos se están presupuestando, qué incluye el ' +
        'trabajo (montaje, cableado, trámites con la distribuidora) y qué garantía cubre la propia ' +
        'instalación, no solo el equipo. Un precio más bajo con componentes más económicos y menos ' +
        'garantía de mano de obra no siempre sale más barato a largo plazo.',
    },
    {
      type: 'heading',
      text: '4. No tener en cuenta las ayudas al calcular la rentabilidad',
    },
    {
      type: 'paragraph',
      text:
        'Las ayudas del IDAE y las convocatorias autonómicas, junto con la compensación de ' +
        'excedentes, pueden reducir de forma notable el coste real de la instalación, pero las ' +
        'condiciones y los importes cambian de una convocatoria a otra - conviene consultar las ' +
        'bases vigentes antes de comparar la "rentabilidad" de varios presupuestos. Algunas ' +
        'empresas incluyen la ayuda ya descontada en el precio, otras no, así que conviene ' +
        'preguntar explícitamente si el precio indicado es antes o después de la subvención.',
    },
    {
      type: 'heading',
      text: '5. No comprobar reseñas ni el alcance real de la garantía',
    },
    {
      type: 'paragraph',
      text:
        'El precio y la ficha técnica no lo son todo - conviene revisar reseñas de proyectos ' +
        'anteriores, a ser posible de clientes de una zona similar, y preguntar exactamente qué ' +
        'cubre la garantía de instalación (que no es lo mismo que la garantía del fabricante de los ' +
        'paneles o el inversor) y cómo funciona el servicio postventa si algo falla tras la ' +
        'instalación.',
    },
    {
      type: 'heading',
      text: 'Cómo se resuelve esto en Roofora',
    },
    {
      type: 'list',
      items: [
        'Una única solicitud anónima llega a la vez a varias empresas instaladoras de su región',
        'El teléfono y el correo solo se dan cuando usted elige a una empresa concreta, y no antes',
        'Los presupuestos se ven ordenados por precio, con calma y sin presión de tiempo',
        'Las empresas pueden actualizar su presupuesto en cualquier momento, así que la comparación siempre está al día',
      ],
    },
  ],
  relatedLinks: [
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
    { label: '¿Cuánto cuesta una instalación fotovoltaica?', href: '/coste-instalacion-fotovoltaica' },
  ],
}
